import { Storage } from '@raylink/common/constants/storage'

export const onClientEntry = () => {
  // eslint-disable-next-line no-unused-vars
  function getCookie(name) {
    const parts = document.cookie.split(/;\s*/)
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < parts.length; i++) {
      const partMap = parts[i].split('=')
      if (partMap[0] === name) {
        return partMap[1]
      }
    }
    return null
  }

  function setCookie(name, value, Days) {
    const domain = '.raylink.live'
    if (Days !== undefined) {
      const OneDay = 24 * 60 * 60
      const maxAge = OneDay * Days
      document.cookie = `${name}=${value};max-age=${maxAge};expires=${new Date(
        Date.now() + maxAge * 1000
      )};path=/;domain=${domain}`
    } else {
      // 不传入过期时间时，设置的 cookie 有效期为 Session，即只在当前会话有效，浏览器一旦关闭，该 Cookie 就会被删除
      document.cookie = `${name}=${value};path=/;domain=${domain}`
    }
  }

  // 记录不含utm_source的来源地址（抓取首页的上一个地址）
  if (!sessionStorage.getItem(Storage.comefrom)) {
    let referrer = document.referrer || document.URL
    if (document.referrer) {
      if (referrer.includes('&')) {
        referrer = `${referrer}&${window.location.search.slice(1)}`
      } else {
        referrer += window.location.search
      }
    }

    if (typeof window !== 'undefined') {
      sessionStorage.setItem(Storage.comefrom, referrer)
    }

    setCookie(Storage.comefrom, referrer)
  }
}
